import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { RoutingGuideType } from "~/shared/schemas/routing-guide-schema.ts";

type RoutingGuideAutoSelectCellProps = GridCustomCellProps & {
	testId?: string;
};

export const RoutingGuideAutoSelectCell = (
	props: RoutingGuideAutoSelectCellProps,
) => {
	const item = props.dataItem as RoutingGuideType;

	let label: string;
	if (!item.isAutoSelected) {
		label = "Disabled";
	} else if (item.selectionMethod === 2) {
		label = "Enabled - Lowest Cost & Fastest Transit Time";
	} else {
		label = "Enabled - Lowest Cost Carrier";
	}

	return (
		<GridTd data-testid={props.testId} tdProps={props.tdProps}>
			{label}
		</GridTd>
	);
};
